import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Broker } from '@c4/core';

import { Room, Device, Location } from '../../common/interfaces/item.interface';
import { Event } from '../../common/interfaces/event.interface';
import { SharedProgrammingService, CommonProgrammingContext } from '../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../common/services/utils.service';
import { RemoteProgrammingContext } from './quickstart-remotes.service';

export interface RemoteProgrammingContext {
  room: Location;
  events: Event[];
}

const INITIAL_STATE: RemoteProgrammingContext = {
  room: undefined,
  events: []
};

const STORE_NAME: string = 'QUICKSTART_REMOTES:';
const SET_SELECTED_ROOM: string = STORE_NAME + 'SET_SELECTED_ROOM';
const SET_ROOM_EVENTS: string = STORE_NAME + 'SET_ROOM_EVENTS';

export function remoteProgrammingReducer(state: RemoteProgrammingContext = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case SET_SELECTED_ROOM: return Object.assign({}, state, { room: payload });
    case SET_ROOM_EVENTS: return Object.assign({}, state, { events: payload });

    default: return state;
  }
}

const SUPPORTED_PROXIES = [
  'control4_sr260'
];

const EVENT_WHITELIST = [
  // 2072, // red button
  // 2073, // green button
  // 2074, // yellow button
  // 2075, // blue button
  2084, // custom 1
  2085, // custom 2
  2086  // custom 3
];

@Injectable()
export class QuickstartRemotesService {

  roomEvents: Observable<Event[]>;
  allRooms: Observable<Room[]>;
  selectedRoom: Observable<Location>;
  selectedEvent: Observable<Event>;

  constructor(
    private store: Store<{ remoteProgramming: RemoteProgrammingContext, sharedProgramming: CommonProgrammingContext }>,
    private shared: SharedProgrammingService,
    private utils: Utils,
    private broker: Broker
  ) {
    this.allRooms = this.broker.getObservable({
      path: '/api/v1/locations/rooms'
    });

    this.roomEvents = this.store.select(s => s.remoteProgramming.events);
    this.selectedRoom = this.store.select(s => s.remoteProgramming.room);
    this.selectedEvent = this.store.select(s => s.sharedProgramming.trigger.event);
  }

  setSelectedRoom(room: Location) {
    // NOTE clear the events regardless of our current state
    this.store.dispatch({ type: SET_ROOM_EVENTS, payload: [] });
    this.store.dispatch({ type: SET_SELECTED_ROOM, payload: room });
    if (room) {
      this._getRoomCustomButtonEvents(room);
    }
  }

  getSelectedEvent(event: Event): Promise<Event> {
    return new Promise<Event>((resolve, reject) => {
      // console.log('rem-svc: setting selected event', event);
      if (event && event.eventId) {
        let room: Location = Utils.snapshot<Location>(this.selectedRoom);
        console.log('rem-svc: selected room is ', room);
        if (room) {
          this.broker.call({ path: '/api/v1/items/' + room.id + '/events/' + event.eventId }).then(
            res => {
              // console.log('rem-svc: fetched event is ', res);
              resolve(res[0]);
            },
            err => {
              console.error('remotes-svc: error getting canonical event for remote button', err);
              reject(err);
            });
        } else {
          console.error('remotes-svc: invalid state, no room selected when setting button event');
          reject({ message: 'invalid state, no room selected when setting button event' });
        }
      } else {
        console.error('remotes-svc: invalid state, missing or invalid event given when selecting button', event);
        reject({ message: 'invalid state, missing or invalid event given when selecting button' });
      }
    });
  }

  private _getRoomCustomButtonEvents(room: Location) {
    this.broker.call({
      path: '/api/v1/items/' + room.id + '/events',
      queryString: {
        allevents: true
      }
    }).then((res: Event[]) => {
      for (var i = 0; i < res.length; i++) {
        var evt: any = res[i];
        if (evt.name === 'Commands') {
          let filtered = evt.params[0].values.filter((val: any) => (EVENT_WHITELIST.indexOf(val.eventId) >= 0));
          this.store.dispatch({ type: SET_ROOM_EVENTS, payload: filtered });
          break;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-system-remotes/quickstart-remotes.service.ts